import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { AddCircleOutline as AddCircleOutlineIcon } from '@material-ui/icons';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { translation } from '../../i18n';
import { ExpansionPanel } from '@material-ui/core';
import { ExpansionPanelSummary } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { ExpansionPanelDetails } from '@material-ui/core';
import { QuestionModuleDto } from '../../pages/questionModuleTypes';
import { observer } from 'mobx-react';
import { IObservableValue, observable } from 'mobx';
import QuestionClusterPreview from './QuestionClusterPreview';
import { IconButton } from '@material-ui/core';
import MultilineText from '../MultilineText';

interface Props {
  module: QuestionModuleDto;
  expanded: IObservableValue<string>;
  handleAdd?: (module: QuestionModuleDto) => void;
}

type LocalStyles = 'root' | 'button' | 'heading' | 'summaryArea' | 'detailArea' | 'chip';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    paddingLeft: theme.spacing.unit
  },
  summaryArea: {
    alignItems: 'center', display: 'flex',
    flexDirection: 'row',
  },
  detailArea: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left'
  },
  chip: {
    margin: theme.spacing.unit,
  },
});


type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionModulePreview extends React.Component<PropsWithStyle, {}> {

  private expandedCluster: IObservableValue<string> = observable.box('');

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    const {module} = this.props;
    return (
      <ExpansionPanel expanded={this.props.expanded.get() === (module.id + 'module')} onChange={() => {
        if (this.props.expanded.get() === (module.id + 'module')) {
          this.props.expanded.set('')
        } else {
          this.props.expanded.set(module.id + 'module')
        }

      }} key={module.id + 'module-panel'}>
        <ExpansionPanelSummary key={module.id + 'module-summary'} expandIcon={<ExpandMoreIcon/>}>
          <div className={this.props.classes.summaryArea}>
            {
              this.props.handleAdd &&
              <div>
                <IconButton onClick={(event) => {
                  event.stopPropagation();
                  this.props.expanded.set('');
                  this.props.handleAdd!!(this.props.module);
                }}>
                  <AddCircleOutlineIcon color={'primary'}/>
                </IconButton>
              </div>
            }

            <div>
              {
                module.title ?
                  <Typography className={this.props.classes.heading}>{module.title}</Typography> :
                  <Typography className={this.props.classes.heading}>
                    {translation.t('createCatalogueComponent.noModuleTitle')}
                  </Typography>
              }
            </div>
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={this.props.classes.detailArea} key={module.id + 'module-details'}>
          {
            module.description &&
            <>
              <div>
                <Typography style={{textAlign: 'left'}}>
                  <MultilineText text={module.description}/>
                </Typography>
              </div>
              <br/>
            </>
          }

          <div>
            <Typography style={{textAlign: 'left'}}>
              {translation.t('module.cluster')}:
            </Typography>
          </div>
          <div>
            {
              module.clusters.map(cluster => {
                  return (
                    <QuestionClusterPreview key={cluster.id + 'cluster'} cluster={cluster}
                                            expanded={this.expandedCluster}/>)
                }
              )
            }
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }

}

export default withStyles(localStyles)(QuestionModulePreview);
